module.exports = __webpack_public_path__ + "static/media/pas1_img.5baf71bf.JPG";